import { useTheme } from '@mui/material/styles';
import { DefaultColor } from './manifest';
function isDefaultColor(color) {
    return Object.keys(DefaultColor).includes(color);
}
function getValueByPath(obj, path) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
    return path.split('.').reduce((acc, part) => {
        if (acc && Object.prototype.hasOwnProperty.call(acc, part)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
            return acc?.[part];
        }
        return undefined;
    }, obj);
}
export function usePaletteColor(color) {
    const theme = useTheme();
    return getPaletteColor(theme, color);
}
export function getPaletteColor(theme, color) {
    if (!color) {
        return undefined;
    }
    if (typeof color === 'function') {
        return color(theme);
    }
    if (color === 'inherit') {
        return 'inherit';
    }
    const colorPath = (isDefaultColor(color) ? `${color}.main` : color);
    return getValueByPath(theme.palette, colorPath);
}
